import { FileRef } from "./fileDto";

export class Notification {
    static fromJson(n: Notification): any {
      throw new Error('Method not implemented.');
    }
      public id: number;
      public created: Date;
      public userId: number;
      public actorId: number;
      public type: NotificationType;
      post?: {
        id: number;
        title: string;
        headline: string;
        userId: number;
        createdAt: string;
      };
      comment?: {
          id: number;
          content: string;
      };
      friendshipRequest?: {
        from: {
            id: number;
            firstName: string;
            lastName: string;
            profilePicture?: string;
        };
        to: {
            id: number;
            firstName: string;
            lastName: string;
            profilePicture?: string;
        };
        status: string;
      };
      public isRead: boolean;
      public text: string;
      public actorProfilePicture?: FileRef;
      public paused: boolean; // ✅ This will now always be available

    constructor(
      id: number,
      created: Date,
      userId: number,
      actorId: number,
      type: NotificationType,
      isRead: boolean,
      text: string,
      actorProfilePicture?: FileRef,
      paused: boolean = false // ✅ Optional default value in case backend omits it
    ) {
      this.id = id;
      this.created = created;
      this.userId = userId;
      this.actorId = actorId;
      this.type = type;
      this.isRead = isRead;
      this.text = text;
      this.actorProfilePicture = actorProfilePicture;
      this.paused = paused ?? false; // ✅ Fallback if paused is undefined
    }
  }


export enum NotificationType {
    Like = 0,
    Comment = 1,
    Share = 2,
    FriendRequest = 3,
    FriendAccepted = 4,
    Follow = 5,
    EventCancelled = 6
}
